import React from 'react';
import { Chip } from '@heroui/react';

interface SidebarChipProps {
  children: React.ReactNode;
  ariaLabel?: string;
  className?: string;
}

const SidebarChip = React.memo<SidebarChipProps>(({ children, ariaLabel, className = '' }) => {
  return (
    <Chip
      className={`sidebar-chip h-5 group-data-[selected=true]:text-white group-data-[selected=true]:bg-auth-strength-none/40 ${className}`}
      size="sm"
      variant="flat"
      aria-label={ariaLabel}
    >
      <span className="font-medium">{children}</span>
    </Chip>
  );
});

SidebarChip.displayName = 'SidebarChip';

export default SidebarChip;
